import { WarningAmberOutlined } from '@mui/icons-material';
import { Box, Tooltip } from '@mui/material';
import { useFormikContext } from 'formik';
import { useMemo } from 'react';

import useTranslate from 'hooks/useTranslate';
import type { ProgramQuestion } from 'types';
import {
    questionWarningCount,
    type ProgramQuestionValues,
} from 'views/v2/programQuestions/formState';

interface QuestionWarningIconProps {
    count: number;
}

interface QuestionFormWarningsProps {
    questions: ProgramQuestion[];
}

export const QuestionWarningIcon: React.FC<QuestionWarningIconProps> = ({ count }) => {
    const { translate } = useTranslate();
    if (count === 0) return null;

    const label = translate(
        count === 1 ? 'programQuestionWarning' : 'programQuestionWarnings'
    ).replace('{{count}}', String(count));

    return (
        <Tooltip title={label}>
            <Box
                component="span"
                role="img"
                aria-label={label}
                tabIndex={0}
                sx={{ display: 'inline-flex', color: 'warning.main', flexShrink: 0 }}
            >
                <WarningAmberOutlined fontSize="small" />
            </Box>
        </Tooltip>
    );
};

export const QuestionFormWarnings: React.FC<QuestionFormWarningsProps> = ({ questions }) => {
    const { values, errors } = useFormikContext<ProgramQuestionValues>();
    const count = useMemo(
        () => questionWarningCount(questions, values, errors),
        [questions, values, errors]
    );

    return <QuestionWarningIcon count={count} />;
};
